<!-- breadcrumb -->
<div class="container marginMobile">
    <div class="col-sm-12 breadcrumb py-3 m-0">
      <a href="#">Accueil</a>&nbsp;>&nbsp;<a href="#">Contact</a>
    </div>
  </div>
  <!-- Fin breadcrumb -->
  <div class="container py-0">
      <div class="row">
        <div class="col-md-12 col-lg-6 d-none d-lg-block">
          <div class="colMap">
  
          </div>
        </div>
         <div class="col-md-12 col-lg-6 p-4">
           <div class="col-sm-12 titreRubrique text-start">
               CONTACTEZ-NOUS
               <div class="separTitres m-0"></div>
            </div>
            <form class="mt-4">
                <!-- <div class="form-floating mb-3">
                    <select class="form-select" id="floatingSelect" aria-label="Floating label select example">
                      <option selected>Veuillez choisir...</option>
                      <option value="1">Commercial</option>
                      <option value="2">Finance</option>
                    </select>
                    <label for="floatingSelect">Département</label>
                  </div> -->
                  <div class="row">
                  <div class="form-floating col-6 mb-3">
                    <input type="text" class="form-control" id="nom" placeholder="Votre nom">
                    <label for="nom">Nom</label>
                  </div>
                  <div class="form-floating col-6 mb-3">
                    <input type="text" class="form-control" id="prenom" placeholder="Votre Prénom">
                    <label for="prenom">Prénom</label>
                  </div>
                  <div class="form-floating col-6 mb-3">
                      <input type="email" class="form-control" id="email" placeholder="name@example.com">
                      <label for="email">E-mail</label>
                  </div>
                  <div class="form-floating col-6 mb-3">
                      <input type="tel" class="form-control" id="telephone" placeholder="06 00 00 00 00">
                      <label for="telephone">Téléphone</label>
                  </div>
                  <div class="form-floating mb-3">
                    <select class="form-select" id="ville" aria-label="Floating label select example">
                      <option value="">Veuillez Choisir une ville..</option>
                      <option value="552">Agadir</option>
                      <option value="553">Al hoceima</option>
                      <option value="554">Aoussered</option>
                      <option value="555">Assilah</option>
                      <option value="609">Autre ville</option>
                      <option value="556">Azrou</option>
                      <option value="808">Ben ahmed</option>
                      <option value="557">Beni mellal</option>
                      <option value="558">Benslimane</option>
                      <option value="559">Berkane</option>
                      <option value="560">Berrechid</option>
                      <option value="561">Boujdour</option>
                      <option value="562">Bouskoura</option>
                      <option value="792">Bouznika</option>
                      <option value="563">Casablanca</option>
                      <option value="564">Chafchaouen</option>
                      <option value="565">Dakhla</option>
                      <option value="827">El hajeb</option>
                      <option value="566">El jadida</option>
                      <option value="793">Errachidia</option>
                      <option value="567">Essaouira</option>
                      <option value="568">Essmara</option>
                      <option value="569">Fès</option>
                      <option value="802">Fkih ben salah</option>
                      <option value="570">Guelmim</option>
                      <option value="801">Guercif</option>
                      <option value="571">Ifrane</option>
                      <option value="830">Imouzzer kandar</option>
                      <option value="573">Kénitra</option>
                      <option value="572">Kabila</option>
                      <option value="575">Khemisset</option>
                      <option value="574">Khenifra</option>
                      <option value="576">Khouribga</option>
                      <option value="577">Ksar el kebir</option>
                      <option value="578">Laayoune</option>
                      <option value="579">Larache</option>
                      <option value="580">Marrakech</option>
                      <option value="581">Martil</option>
                      <option value="582">Meknès</option>
                      <option value="583">Melilia</option>
                      <option value="584">Midelt</option>
                      <option value="585">Mohammedia</option>
                      <option value="586">Nador</option>
                      <option value="794">Oualidia</option>
                      <option value="587">Ouarzazate</option>
                      <option value="588">Ouazzane</option>
                      <option value="589">Oujda</option>
                      <option value="590">Rabat</option>
                      <option value="591">Safi</option>
                      <option value="795">Saidia</option>
                      <option value="592">Salé</option>
                      <option value="593">Sebta</option>
                      <option value="594">Sefrou</option>
                      <option value="595">Settat</option>
                      <option value="806">Sidi bennour</option>
                      <option value="596">Sidi ifni</option>
                      <option value="597">Sidi kacem</option>
                      <option value="598">Sidi rahal</option>
                      <option value="807">Sidi slimane</option>
                      <option value="831">Souk elarbaa du gharb</option>
                      <option value="599">Tamensourte</option>
                      <option value="600">Tamesna</option>
                      <option value="601">Tanger</option>
                      <option value="602">Tantan</option>
                      <option value="603">Tarfaya</option>
                      <option value="800">Taroudant</option>
                      <option value="604">Taza</option>
                      <option value="605" selected="selected">Temara</option>
                      <option value="606">Tetouan</option>
                      <option value="607">Tifelt</option>
                      <option value="798">Tinghir</option>
                      <option value="608">Tiznit</option>
                      <option value="799">Tout le maroc</option>
                      <option value="829">Youssoufia</option>
                      <option value="828">Zagora</option>
                    </select>
                      <label for="ville">Ville</label>
                  </div>
                  <div class="form-floating mb-3">
                    <input type="tel" class="form-control" id="Adresse" placeholder="Votre adresse...">
                    <label for="Adresse">Adresse</label>
                </div>
                <div class="form-floating">
                    <textarea class="form-control" placeholder="Leave a comment here" id="floatingTextarea2" style="height: 100px"></textarea>
                    <label for="floatingTextarea2">Message</label>
                </div>
                <div class="mb-3 btnSubmit">
                    <button type="submit" class="btn btn-primary">Envoyer</button>
                </div>
              </div>
              </form>
         </div>
      </div>
  </div>
  
  <div class="container mt-5">
    <div class="row">
      <div class="col-sm-12 my-4">
        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13302.83913263891!2d-7.575193!3d33.5349304!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xc54528a8a6acead9!2sCERATUBE!5e0!3m2!1sfr!2sma!4v1643821693197!5m2!1sfr!2sma"
          width="100%" height="350px" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
       </div>
    </div>
  </div>
  
  <div class="container bgCoordonnes">
    <div class="row">
        <div class="col-6 col-md-6 col-lg-3">
            <div class="colCoor">
                <div class="contactIcon"><i class="fa fa-phone"></i></div>
                <p class="contactCoor m-0"><a href="tel:+212661171546">06 61 17 15 46</a></p>
            </div>
        </div>
        <div class="col-6 col-md-6 col-lg-3">
            <div class="colCoor"> 
                <div class="contactIcon"><i class="fa fa-fax"></i></div>
                <p class="contactCoor m-0"><a href="fax:+212522508061">05 22 50 80 60</a></p>
            </div>
        </div>
        <div class="col-6 col-md-6 col-lg-3">
            <div class="colCoor">
                <div class="contactIcon"><i class="fa fa-envelope"></i></div>
                <p class="contactCoor"><a href="mailto:info@ceratube.ma">info@ceratube.ma</a></p>
            </div>
        </div>
        <div class="col-6 col-md-6 col-lg-3">
            <div class="colCoor">
                <div class="contactIcon"><i class="fa fa-map-marker"></i></div>
                <p class="contactCoor"><a href="https://www.google.com/maps/place/CERATUBE/@33.5349349,-7.577387,17z/data=!3m1!4b1!4m5!3m4!1s0xda632ee63dcf59f:0xc54528a8a6acead9!8m2!3d33.5349304!4d-7.575193" target="_blank">Ceratube sarl  9, Lotissement Bled Amrane, Bd Mohamed VI, Ain Chock Casablanca</a></p>
                <p class="contactCoor"><a href="https://goo.gl/maps/Wmdx5YTi82c1vBQE9" target="_blank"><strong>Dépôt :</strong> Z.I. Sapino N° 485, Nouaceur</a></p>
            </div>
        </div>
    </div>
  </div>